/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Identity Management
 * The Identity Management API can be used to manage roles,
 * users, market participants and service accounts.
 * OpenAPI spec version: 0.0.1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ApplicationRole,
  AuditEvent,
  AuditEventV3,
  ExportOrganizationAuditTimelineParams,
  ExportOrganizationLastLoginsParams,
  GetAuditEventsParams,
  GetMarketParticipantsParams,
  GetOrganizationRoleAssignmentsParams,
  GetOrganizationRoleServiceRoleAssignmentsParams,
  GetOrganizationRolesParams,
  GetServiceAccountsParams,
  GetUsersParams,
  LastLoginsResponse,
  MarketParticipant,
  Organization,
  OrganizationRequest,
  OrganizationRole,
  OrganizationRoleAssignment,
  OrganizationRoleAssignmentAction,
  OrganizationRoleRequest,
  OrganizationRoleServiceRoleAssignment,
  OrganizationRoleServiceRoleAssignmentAction,
  PaginatedUsers,
  PatchId,
  ProblemDetails,
  Service,
  ServiceAccount,
  ServiceAccountRequest,
  ServiceAccountResponseV2,
  ServiceRole,
  ServiceRoleAssignment,
  ServiceRoleAssignmentAction,
  User,
  UserRequest
} from './model';

import { fetchInstance } from '../fetchInstance';
type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Retrieve all service role assignments (organizationId, roleName, userId)
 * @summary Get Service Role Assignments
 */
export const getServiceRoleAssignments = (

 signal?: AbortSignal
) => {


      return fetchInstance<ServiceRoleAssignment[]>(
      {url: `/idm/v1/service-role-assignments`, method: 'GET', signal
    },
      );
    }




export const getGetServiceRoleAssignmentsQueryKey = () => {
    return [
    `/idm/v1/service-role-assignments`
    ] as const;
    }


export const getGetServiceRoleAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError = ProblemDetails | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceRoleAssignmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceRoleAssignments>>> = ({ signal }) => getServiceRoleAssignments(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceRoleAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceRoleAssignments>>>
export type GetServiceRoleAssignmentsQueryError = ProblemDetails | void


export function useGetServiceRoleAssignments<TData = Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError = ProblemDetails | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceRoleAssignments>>,
          TError,
          Awaited<ReturnType<typeof getServiceRoleAssignments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceRoleAssignments<TData = Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceRoleAssignments>>,
          TError,
          Awaited<ReturnType<typeof getServiceRoleAssignments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceRoleAssignments<TData = Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Service Role Assignments
 */

export function useGetServiceRoleAssignments<TData = Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceRoleAssignmentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetServiceRoleAssignmentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError = ProblemDetails | void>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceRoleAssignmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceRoleAssignments>>> = ({ signal }) => getServiceRoleAssignments(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetServiceRoleAssignmentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceRoleAssignments>>>
export type GetServiceRoleAssignmentsSuspenseQueryError = ProblemDetails | void


export function useGetServiceRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError = ProblemDetails | void>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Service Role Assignments
 */

export function useGetServiceRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceRoleAssignmentsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Add or delete service role assignments via actions array
 * @summary Patch Service Role Assignments
 */
export const patchServiceRoleAssignments = (
    serviceRoleAssignmentAction: ServiceRoleAssignmentAction[],
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v1/service-role-assignments`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: serviceRoleAssignmentAction, signal
    },
      );
    }




export const getPatchServiceRoleAssignmentsMutationKey = () => ['patchServiceRoleAssignments'] as const;

export const getPatchServiceRoleAssignmentsMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceRoleAssignments>>, TError,PatchServiceRoleAssignmentsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchServiceRoleAssignments>>, TError,PatchServiceRoleAssignmentsMutationVariables, TContext> => {

const mutationKey = getPatchServiceRoleAssignmentsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchServiceRoleAssignments>>, PatchServiceRoleAssignmentsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patchServiceRoleAssignments(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchServiceRoleAssignmentsMutationResult = NonNullable<Awaited<ReturnType<typeof patchServiceRoleAssignments>>>
    export type PatchServiceRoleAssignmentsMutationBody = ServiceRoleAssignmentAction[]
    export type PatchServiceRoleAssignmentsMutationError = ProblemDetails | void
    export type PatchServiceRoleAssignmentsMutationVariables = {data: ServiceRoleAssignmentAction[]}

    /**
 * @summary Patch Service Role Assignments
 */
export const usePatchServiceRoleAssignments = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceRoleAssignments>>, TError,PatchServiceRoleAssignmentsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchServiceRoleAssignments>>,
        TError,
        PatchServiceRoleAssignmentsMutationVariables,
        TContext
      > => {
      return useMutation(getPatchServiceRoleAssignmentsMutationOptions(options), queryClient);
    }

/**
 * Get a list of application roles.
 * @summary Get Application Roles
 */
export const getApplicationRoles = (

 signal?: AbortSignal
) => {


      return fetchInstance<ApplicationRole[]>(
      {url: `/idm/v2/application-roles`, method: 'GET', signal
    },
      );
    }




export const getGetApplicationRolesQueryKey = () => {
    return [
    `/idm/v2/application-roles`
    ] as const;
    }


export const getGetApplicationRolesQueryOptions = <TData = Awaited<ReturnType<typeof getApplicationRoles>>, TError = ProblemDetails | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicationRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicationRoles>>> = ({ signal }) => getApplicationRoles(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApplicationRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicationRoles>>>
export type GetApplicationRolesQueryError = ProblemDetails | void


export function useGetApplicationRoles<TData = Awaited<ReturnType<typeof getApplicationRoles>>, TError = ProblemDetails | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicationRoles>>,
          TError,
          Awaited<ReturnType<typeof getApplicationRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicationRoles<TData = Awaited<ReturnType<typeof getApplicationRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicationRoles>>,
          TError,
          Awaited<ReturnType<typeof getApplicationRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicationRoles<TData = Awaited<ReturnType<typeof getApplicationRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Application Roles
 */

export function useGetApplicationRoles<TData = Awaited<ReturnType<typeof getApplicationRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicationRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApplicationRolesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApplicationRoles>>, TError = ProblemDetails | void>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicationRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicationRoles>>> = ({ signal }) => getApplicationRoles(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetApplicationRolesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicationRoles>>>
export type GetApplicationRolesSuspenseQueryError = ProblemDetails | void


export function useGetApplicationRolesSuspense<TData = Awaited<ReturnType<typeof getApplicationRoles>>, TError = ProblemDetails | void>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicationRolesSuspense<TData = Awaited<ReturnType<typeof getApplicationRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicationRolesSuspense<TData = Awaited<ReturnType<typeof getApplicationRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Application Roles
 */

export function useGetApplicationRolesSuspense<TData = Awaited<ReturnType<typeof getApplicationRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicationRolesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get an application role by ID.
 * @summary Get Application Role
 */
export const getApplicationRole = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<ApplicationRole>(
      {url: `/idm/v2/application-roles/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetApplicationRoleQueryKey = (id: string,) => {
    return [
    `/idm/v2/application-roles/${id}`
    ] as const;
    }


export const getGetApplicationRoleQueryOptions = <TData = Awaited<ReturnType<typeof getApplicationRole>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicationRoleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicationRole>>> = ({ signal }) => getApplicationRole(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApplicationRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicationRole>>>
export type GetApplicationRoleQueryError = ProblemDetails


export function useGetApplicationRole<TData = Awaited<ReturnType<typeof getApplicationRole>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicationRole>>,
          TError,
          Awaited<ReturnType<typeof getApplicationRole>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicationRole<TData = Awaited<ReturnType<typeof getApplicationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicationRole>>,
          TError,
          Awaited<ReturnType<typeof getApplicationRole>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicationRole<TData = Awaited<ReturnType<typeof getApplicationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Application Role
 */

export function useGetApplicationRole<TData = Awaited<ReturnType<typeof getApplicationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicationRoleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApplicationRoleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApplicationRole>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicationRoleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicationRole>>> = ({ signal }) => getApplicationRole(id, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetApplicationRoleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicationRole>>>
export type GetApplicationRoleSuspenseQueryError = ProblemDetails


export function useGetApplicationRoleSuspense<TData = Awaited<ReturnType<typeof getApplicationRole>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicationRoleSuspense<TData = Awaited<ReturnType<typeof getApplicationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicationRoleSuspense<TData = Awaited<ReturnType<typeof getApplicationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Application Role
 */

export function useGetApplicationRoleSuspense<TData = Awaited<ReturnType<typeof getApplicationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApplicationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicationRoleSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Add or remove service accounts from an application role.
 * @summary Patch Application Role ServiceAccounts
 */
export const patchApplicationRoleServiceAccounts = (
    id: string,
    patchId: PatchId[],
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v2/application-roles/${id}/service-accounts`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchId, signal
    },
      );
    }




export const getPatchApplicationRoleServiceAccountsMutationKey = () => ['patchApplicationRoleServiceAccounts'] as const;

export const getPatchApplicationRoleServiceAccountsMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApplicationRoleServiceAccounts>>, TError,PatchApplicationRoleServiceAccountsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApplicationRoleServiceAccounts>>, TError,PatchApplicationRoleServiceAccountsMutationVariables, TContext> => {

const mutationKey = getPatchApplicationRoleServiceAccountsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApplicationRoleServiceAccounts>>, PatchApplicationRoleServiceAccountsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patchApplicationRoleServiceAccounts(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApplicationRoleServiceAccountsMutationResult = NonNullable<Awaited<ReturnType<typeof patchApplicationRoleServiceAccounts>>>
    export type PatchApplicationRoleServiceAccountsMutationBody = PatchId[]
    export type PatchApplicationRoleServiceAccountsMutationError = ProblemDetails | void
    export type PatchApplicationRoleServiceAccountsMutationVariables = {id: string;data: PatchId[]}

    /**
 * @summary Patch Application Role ServiceAccounts
 */
export const usePatchApplicationRoleServiceAccounts = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApplicationRoleServiceAccounts>>, TError,PatchApplicationRoleServiceAccountsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApplicationRoleServiceAccounts>>,
        TError,
        PatchApplicationRoleServiceAccountsMutationVariables,
        TContext
      > => {
      return useMutation(getPatchApplicationRoleServiceAccountsMutationOptions(options), queryClient);
    }

/**
 * Add or remove users from an application role.
 * @summary Patch Application Role Users
 */
export const patchApplicationRoleUsers = (
    id: string,
    patchId: PatchId[],
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v2/application-roles/${id}/users`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchId, signal
    },
      );
    }




export const getPatchApplicationRoleUsersMutationKey = () => ['patchApplicationRoleUsers'] as const;

export const getPatchApplicationRoleUsersMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApplicationRoleUsers>>, TError,PatchApplicationRoleUsersMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApplicationRoleUsers>>, TError,PatchApplicationRoleUsersMutationVariables, TContext> => {

const mutationKey = getPatchApplicationRoleUsersMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApplicationRoleUsers>>, PatchApplicationRoleUsersMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patchApplicationRoleUsers(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApplicationRoleUsersMutationResult = NonNullable<Awaited<ReturnType<typeof patchApplicationRoleUsers>>>
    export type PatchApplicationRoleUsersMutationBody = PatchId[]
    export type PatchApplicationRoleUsersMutationError = ProblemDetails | void
    export type PatchApplicationRoleUsersMutationVariables = {id: string;data: PatchId[]}

    /**
 * @summary Patch Application Role Users
 */
export const usePatchApplicationRoleUsers = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApplicationRoleUsers>>, TError,PatchApplicationRoleUsersMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApplicationRoleUsers>>,
        TError,
        PatchApplicationRoleUsersMutationVariables,
        TContext
      > => {
      return useMutation(getPatchApplicationRoleUsersMutationOptions(options), queryClient);
    }

/**
 * Get a list of organizations.
 * @summary Get Organizations
 */
export const getOrganizations = (

 signal?: AbortSignal
) => {


      return fetchInstance<Organization[]>(
      {url: `/idm/v3/organizations`, method: 'GET', signal
    },
      );
    }




export const getGetOrganizationsQueryKey = () => {
    return [
    `/idm/v3/organizations`
    ] as const;
    }


export const getGetOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ProblemDetails | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizations>>> = ({ signal }) => getOrganizations(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizations>>>
export type GetOrganizationsQueryError = ProblemDetails | void


export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ProblemDetails | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organizations
 */

export function useGetOrganizations<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrganizationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ProblemDetails | void>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizations>>> = ({ signal }) => getOrganizations(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetOrganizationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizations>>>
export type GetOrganizationsSuspenseQueryError = ProblemDetails | void


export function useGetOrganizationsSuspense<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ProblemDetails | void>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationsSuspense<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationsSuspense<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organizations
 */

export function useGetOrganizationsSuspense<TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get an organization by ID.
 * @summary Get Organization
 */
export const getOrganization = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<Organization>(
      {url: `/idm/v3/organizations/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetOrganizationQueryKey = (id: string,) => {
    return [
    `/idm/v3/organizations/${id}`
    ] as const;
    }


export const getGetOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof getOrganization>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({ signal }) => getOrganization(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganization>>>
export type GetOrganizationQueryError = ProblemDetails


export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization
 */

export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrganizationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrganization>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({ signal }) => getOrganization(id, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetOrganizationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganization>>>
export type GetOrganizationSuspenseQueryError = ProblemDetails


export function useGetOrganizationSuspense<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationSuspense<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationSuspense<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization
 */

export function useGetOrganizationSuspense<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete a organization.
 * @summary Delete Organization
 */
export const deleteOrganization = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v3/organizations/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteOrganizationMutationKey = () => ['deleteOrganization'] as const;

export const getDeleteOrganizationMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganization>>, TError,DeleteOrganizationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganization>>, TError,DeleteOrganizationMutationVariables, TContext> => {

const mutationKey = getDeleteOrganizationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganization>>, DeleteOrganizationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteOrganization(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganization>>>

    export type DeleteOrganizationMutationError = ProblemDetails | void
    export type DeleteOrganizationMutationVariables = {id: string}

    /**
 * @summary Delete Organization
 */
export const useDeleteOrganization = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganization>>, TError,DeleteOrganizationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrganization>>,
        TError,
        DeleteOrganizationMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOrganizationMutationOptions(options), queryClient);
    }

/**
 * Update a organization by id. Or create it if it doesn't exist.
 * @summary Update Organization
 */
export const updateOrganization = (
    id: string,
    organizationRequest: OrganizationRequest,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v3/organizations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: organizationRequest, signal
    },
      );
    }




export const getUpdateOrganizationMutationKey = () => ['updateOrganization'] as const;

export const getUpdateOrganizationMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,UpdateOrganizationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,UpdateOrganizationMutationVariables, TContext> => {

const mutationKey = getUpdateOrganizationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganization>>, UpdateOrganizationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrganization(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganization>>>
    export type UpdateOrganizationMutationBody = OrganizationRequest
    export type UpdateOrganizationMutationError = ProblemDetails | void
    export type UpdateOrganizationMutationVariables = {id: string;data: OrganizationRequest}

    /**
 * @summary Update Organization
 */
export const useUpdateOrganization = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,UpdateOrganizationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganization>>,
        TError,
        UpdateOrganizationMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOrganizationMutationOptions(options), queryClient);
    }

/**
 * Get a list of service accounts.
 * @summary Get ServiceAccounts
 */
export const getServiceAccounts = (
    params?: GetServiceAccountsParams,
 signal?: AbortSignal
) => {


      return fetchInstance<ServiceAccount[]>(
      {url: `/idm/v4/service-accounts`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetServiceAccountsQueryKey = (params?: GetServiceAccountsParams,) => {
    return [
    `/idm/v4/service-accounts`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetServiceAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getServiceAccounts>>, TError = ProblemDetails | void>(params?: GetServiceAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceAccounts>>> = ({ signal }) => getServiceAccounts(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceAccounts>>>
export type GetServiceAccountsQueryError = ProblemDetails | void


export function useGetServiceAccounts<TData = Awaited<ReturnType<typeof getServiceAccounts>>, TError = ProblemDetails | void>(
 params: undefined |  GetServiceAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceAccounts>>,
          TError,
          Awaited<ReturnType<typeof getServiceAccounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccounts<TData = Awaited<ReturnType<typeof getServiceAccounts>>, TError = ProblemDetails | void>(
 params?: GetServiceAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceAccounts>>,
          TError,
          Awaited<ReturnType<typeof getServiceAccounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccounts<TData = Awaited<ReturnType<typeof getServiceAccounts>>, TError = ProblemDetails | void>(
 params?: GetServiceAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get ServiceAccounts
 */

export function useGetServiceAccounts<TData = Awaited<ReturnType<typeof getServiceAccounts>>, TError = ProblemDetails | void>(
 params?: GetServiceAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetServiceAccountsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServiceAccounts>>, TError = ProblemDetails | void>(params?: GetServiceAccountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceAccounts>>> = ({ signal }) => getServiceAccounts(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetServiceAccountsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceAccounts>>>
export type GetServiceAccountsSuspenseQueryError = ProblemDetails | void


export function useGetServiceAccountsSuspense<TData = Awaited<ReturnType<typeof getServiceAccounts>>, TError = ProblemDetails | void>(
 params: undefined |  GetServiceAccountsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccountsSuspense<TData = Awaited<ReturnType<typeof getServiceAccounts>>, TError = ProblemDetails | void>(
 params?: GetServiceAccountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccountsSuspense<TData = Awaited<ReturnType<typeof getServiceAccounts>>, TError = ProblemDetails | void>(
 params?: GetServiceAccountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get ServiceAccounts
 */

export function useGetServiceAccountsSuspense<TData = Awaited<ReturnType<typeof getServiceAccounts>>, TError = ProblemDetails | void>(
 params?: GetServiceAccountsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceAccountsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete a Service Account
 * @summary Delete ServiceAccount
 */
export const deleteServiceAccount = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v4/service-accounts/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteServiceAccountMutationKey = () => ['deleteServiceAccount'] as const;

export const getDeleteServiceAccountMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAccount>>, TError,DeleteServiceAccountMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAccount>>, TError,DeleteServiceAccountMutationVariables, TContext> => {

const mutationKey = getDeleteServiceAccountMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceAccount>>, DeleteServiceAccountMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteServiceAccount(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceAccount>>>

    export type DeleteServiceAccountMutationError = ProblemDetails | void
    export type DeleteServiceAccountMutationVariables = {id: string}

    /**
 * @summary Delete ServiceAccount
 */
export const useDeleteServiceAccount = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAccount>>, TError,DeleteServiceAccountMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceAccount>>,
        TError,
        DeleteServiceAccountMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteServiceAccountMutationOptions(options), queryClient);
    }

/**
 * Get a service account by id
 * @summary Get ServiceAccount
 */
export const getServiceAccount = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<ServiceAccount>(
      {url: `/idm/v4/service-accounts/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetServiceAccountQueryKey = (id: string,) => {
    return [
    `/idm/v4/service-accounts/${id}`
    ] as const;
    }


export const getGetServiceAccountQueryOptions = <TData = Awaited<ReturnType<typeof getServiceAccount>>, TError = ProblemDetails | void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceAccountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceAccount>>> = ({ signal }) => getServiceAccount(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceAccount>>>
export type GetServiceAccountQueryError = ProblemDetails | void


export function useGetServiceAccount<TData = Awaited<ReturnType<typeof getServiceAccount>>, TError = ProblemDetails | void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceAccount>>,
          TError,
          Awaited<ReturnType<typeof getServiceAccount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccount<TData = Awaited<ReturnType<typeof getServiceAccount>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceAccount>>,
          TError,
          Awaited<ReturnType<typeof getServiceAccount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccount<TData = Awaited<ReturnType<typeof getServiceAccount>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get ServiceAccount
 */

export function useGetServiceAccount<TData = Awaited<ReturnType<typeof getServiceAccount>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceAccountQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetServiceAccountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServiceAccount>>, TError = ProblemDetails | void>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceAccountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceAccount>>> = ({ signal }) => getServiceAccount(id, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetServiceAccountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceAccount>>>
export type GetServiceAccountSuspenseQueryError = ProblemDetails | void


export function useGetServiceAccountSuspense<TData = Awaited<ReturnType<typeof getServiceAccount>>, TError = ProblemDetails | void>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccountSuspense<TData = Awaited<ReturnType<typeof getServiceAccount>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccountSuspense<TData = Awaited<ReturnType<typeof getServiceAccount>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get ServiceAccount
 */

export function useGetServiceAccountSuspense<TData = Awaited<ReturnType<typeof getServiceAccount>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceAccountSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Creates or updates a Service Account with a given ID
 * @summary Update ServiceAccount
 */
export const updateServiceAccount = (
    id: string,
    serviceAccountRequest: ServiceAccountRequest,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v4/service-accounts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: serviceAccountRequest, signal
    },
      );
    }




export const getUpdateServiceAccountMutationKey = () => ['updateServiceAccount'] as const;

export const getUpdateServiceAccountMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceAccount>>, TError,UpdateServiceAccountMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateServiceAccount>>, TError,UpdateServiceAccountMutationVariables, TContext> => {

const mutationKey = getUpdateServiceAccountMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateServiceAccount>>, UpdateServiceAccountMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateServiceAccount(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateServiceAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateServiceAccount>>>
    export type UpdateServiceAccountMutationBody = ServiceAccountRequest
    export type UpdateServiceAccountMutationError = ProblemDetails | void
    export type UpdateServiceAccountMutationVariables = {id: string;data: ServiceAccountRequest}

    /**
 * @summary Update ServiceAccount
 */
export const useUpdateServiceAccount = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceAccount>>, TError,UpdateServiceAccountMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateServiceAccount>>,
        TError,
        UpdateServiceAccountMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateServiceAccountMutationOptions(options), queryClient);
    }

/**
 * Get a list of service roles
 * @summary Get ServiceRoles
 */
export const getServiceRoles = (

 signal?: AbortSignal
) => {


      return fetchInstance<ServiceRole[]>(
      {url: `/idm/v3/service-roles`, method: 'GET', signal
    },
      );
    }




export const getGetServiceRolesQueryKey = () => {
    return [
    `/idm/v3/service-roles`
    ] as const;
    }


export const getGetServiceRolesQueryOptions = <TData = Awaited<ReturnType<typeof getServiceRoles>>, TError = ProblemDetails | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceRoles>>> = ({ signal }) => getServiceRoles(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceRoles>>>
export type GetServiceRolesQueryError = ProblemDetails | void


export function useGetServiceRoles<TData = Awaited<ReturnType<typeof getServiceRoles>>, TError = ProblemDetails | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceRoles>>,
          TError,
          Awaited<ReturnType<typeof getServiceRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceRoles<TData = Awaited<ReturnType<typeof getServiceRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceRoles>>,
          TError,
          Awaited<ReturnType<typeof getServiceRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceRoles<TData = Awaited<ReturnType<typeof getServiceRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get ServiceRoles
 */

export function useGetServiceRoles<TData = Awaited<ReturnType<typeof getServiceRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetServiceRolesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServiceRoles>>, TError = ProblemDetails | void>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceRoles>>> = ({ signal }) => getServiceRoles(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetServiceRolesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceRoles>>>
export type GetServiceRolesSuspenseQueryError = ProblemDetails | void


export function useGetServiceRolesSuspense<TData = Awaited<ReturnType<typeof getServiceRoles>>, TError = ProblemDetails | void>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceRolesSuspense<TData = Awaited<ReturnType<typeof getServiceRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceRolesSuspense<TData = Awaited<ReturnType<typeof getServiceRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get ServiceRoles
 */

export function useGetServiceRolesSuspense<TData = Awaited<ReturnType<typeof getServiceRoles>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceRolesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Retrieve all organization role assignments
 * @summary Get Organization Role Assignments
 */
export const getOrganizationRoleAssignments = (
    params?: GetOrganizationRoleAssignmentsParams,
 signal?: AbortSignal
) => {


      return fetchInstance<OrganizationRoleAssignment[]>(
      {url: `/idm/v1/organization-role-assignments`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOrganizationRoleAssignmentsQueryKey = (params?: GetOrganizationRoleAssignmentsParams,) => {
    return [
    `/idm/v1/organization-role-assignments`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganizationRoleAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError = ProblemDetails | void>(params?: GetOrganizationRoleAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationRoleAssignmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>> = ({ signal }) => getOrganizationRoleAssignments(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationRoleAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>>
export type GetOrganizationRoleAssignmentsQueryError = ProblemDetails | void


export function useGetOrganizationRoleAssignments<TData = Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError = ProblemDetails | void>(
 params: undefined |  GetOrganizationRoleAssignmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRoleAssignments>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRoleAssignments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoleAssignments<TData = Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRoleAssignments>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRoleAssignments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoleAssignments<TData = Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Role Assignments
 */

export function useGetOrganizationRoleAssignments<TData = Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationRoleAssignmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrganizationRoleAssignmentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError = ProblemDetails | void>(params?: GetOrganizationRoleAssignmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationRoleAssignmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>> = ({ signal }) => getOrganizationRoleAssignments(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetOrganizationRoleAssignmentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>>
export type GetOrganizationRoleAssignmentsSuspenseQueryError = ProblemDetails | void


export function useGetOrganizationRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError = ProblemDetails | void>(
 params: undefined |  GetOrganizationRoleAssignmentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleAssignmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleAssignmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Role Assignments
 */

export function useGetOrganizationRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleAssignmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationRoleAssignmentsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Add or delete organization role assignments via actions array
 * @summary Patch Organization Role Assignments
 */
export const patchOrganizationRoleAssignments = (
    organizationRoleAssignmentAction: OrganizationRoleAssignmentAction[],
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v1/organization-role-assignments`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: organizationRoleAssignmentAction, signal
    },
      );
    }




export const getPatchOrganizationRoleAssignmentsMutationKey = () => ['patchOrganizationRoleAssignments'] as const;

export const getPatchOrganizationRoleAssignmentsMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOrganizationRoleAssignments>>, TError,PatchOrganizationRoleAssignmentsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchOrganizationRoleAssignments>>, TError,PatchOrganizationRoleAssignmentsMutationVariables, TContext> => {

const mutationKey = getPatchOrganizationRoleAssignmentsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchOrganizationRoleAssignments>>, PatchOrganizationRoleAssignmentsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patchOrganizationRoleAssignments(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchOrganizationRoleAssignmentsMutationResult = NonNullable<Awaited<ReturnType<typeof patchOrganizationRoleAssignments>>>
    export type PatchOrganizationRoleAssignmentsMutationBody = OrganizationRoleAssignmentAction[]
    export type PatchOrganizationRoleAssignmentsMutationError = ProblemDetails | void
    export type PatchOrganizationRoleAssignmentsMutationVariables = {data: OrganizationRoleAssignmentAction[]}

    /**
 * @summary Patch Organization Role Assignments
 */
export const usePatchOrganizationRoleAssignments = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOrganizationRoleAssignments>>, TError,PatchOrganizationRoleAssignmentsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchOrganizationRoleAssignments>>,
        TError,
        PatchOrganizationRoleAssignmentsMutationVariables,
        TContext
      > => {
      return useMutation(getPatchOrganizationRoleAssignmentsMutationOptions(options), queryClient);
    }

/**
 * Retrieve service role links for organization roles visible to the caller
 * @summary Get Organization Role Service Role Assignments
 */
export const getOrganizationRoleServiceRoleAssignments = (
    params?: GetOrganizationRoleServiceRoleAssignmentsParams,
 signal?: AbortSignal
) => {


      return fetchInstance<OrganizationRoleServiceRoleAssignment[]>(
      {url: `/idm/v1/organization-role-service-role-assignments`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOrganizationRoleServiceRoleAssignmentsQueryKey = (params?: GetOrganizationRoleServiceRoleAssignmentsParams,) => {
    return [
    `/idm/v1/organization-role-service-role-assignments`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganizationRoleServiceRoleAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError = ProblemDetails | void>(params?: GetOrganizationRoleServiceRoleAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationRoleServiceRoleAssignmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>> = ({ signal }) => getOrganizationRoleServiceRoleAssignments(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationRoleServiceRoleAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>>
export type GetOrganizationRoleServiceRoleAssignmentsQueryError = ProblemDetails | void


export function useGetOrganizationRoleServiceRoleAssignments<TData = Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError = ProblemDetails | void>(
 params: undefined |  GetOrganizationRoleServiceRoleAssignmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoleServiceRoleAssignments<TData = Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleServiceRoleAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoleServiceRoleAssignments<TData = Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleServiceRoleAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Role Service Role Assignments
 */

export function useGetOrganizationRoleServiceRoleAssignments<TData = Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleServiceRoleAssignmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationRoleServiceRoleAssignmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrganizationRoleServiceRoleAssignmentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError = ProblemDetails | void>(params?: GetOrganizationRoleServiceRoleAssignmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationRoleServiceRoleAssignmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>> = ({ signal }) => getOrganizationRoleServiceRoleAssignments(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetOrganizationRoleServiceRoleAssignmentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>>
export type GetOrganizationRoleServiceRoleAssignmentsSuspenseQueryError = ProblemDetails | void


export function useGetOrganizationRoleServiceRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError = ProblemDetails | void>(
 params: undefined |  GetOrganizationRoleServiceRoleAssignmentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoleServiceRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleServiceRoleAssignmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoleServiceRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleServiceRoleAssignmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Role Service Role Assignments
 */

export function useGetOrganizationRoleServiceRoleAssignmentsSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRoleServiceRoleAssignmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoleServiceRoleAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationRoleServiceRoleAssignmentsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Add or delete service role links for organization roles via actions array
 * @summary Patch Organization Role Service Role Assignments
 */
export const patchOrganizationRoleServiceRoleAssignments = (
    organizationRoleServiceRoleAssignmentAction: OrganizationRoleServiceRoleAssignmentAction[],
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v1/organization-role-service-role-assignments`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: organizationRoleServiceRoleAssignmentAction, signal
    },
      );
    }




export const getPatchOrganizationRoleServiceRoleAssignmentsMutationKey = () => ['patchOrganizationRoleServiceRoleAssignments'] as const;

export const getPatchOrganizationRoleServiceRoleAssignmentsMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOrganizationRoleServiceRoleAssignments>>, TError,PatchOrganizationRoleServiceRoleAssignmentsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchOrganizationRoleServiceRoleAssignments>>, TError,PatchOrganizationRoleServiceRoleAssignmentsMutationVariables, TContext> => {

const mutationKey = getPatchOrganizationRoleServiceRoleAssignmentsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchOrganizationRoleServiceRoleAssignments>>, PatchOrganizationRoleServiceRoleAssignmentsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patchOrganizationRoleServiceRoleAssignments(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchOrganizationRoleServiceRoleAssignmentsMutationResult = NonNullable<Awaited<ReturnType<typeof patchOrganizationRoleServiceRoleAssignments>>>
    export type PatchOrganizationRoleServiceRoleAssignmentsMutationBody = OrganizationRoleServiceRoleAssignmentAction[]
    export type PatchOrganizationRoleServiceRoleAssignmentsMutationError = ProblemDetails | void
    export type PatchOrganizationRoleServiceRoleAssignmentsMutationVariables = {data: OrganizationRoleServiceRoleAssignmentAction[]}

    /**
 * @summary Patch Organization Role Service Role Assignments
 */
export const usePatchOrganizationRoleServiceRoleAssignments = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOrganizationRoleServiceRoleAssignments>>, TError,PatchOrganizationRoleServiceRoleAssignmentsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchOrganizationRoleServiceRoleAssignments>>,
        TError,
        PatchOrganizationRoleServiceRoleAssignmentsMutationVariables,
        TContext
      > => {
      return useMutation(getPatchOrganizationRoleServiceRoleAssignmentsMutationOptions(options), queryClient);
    }

/**
 * Get organization roles visible to the caller. Operators see roles for their directly assigned organizations and descendants, service-desk and privileged accounts see all roles.
 * @summary Get Organization Roles
 */
export const getOrganizationRoles = (
    params?: GetOrganizationRolesParams,
 signal?: AbortSignal
) => {


      return fetchInstance<OrganizationRole[]>(
      {url: `/idm/v3/organization-roles`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOrganizationRolesQueryKey = (params?: GetOrganizationRolesParams,) => {
    return [
    `/idm/v3/organization-roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganizationRolesQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationRoles>>, TError = ProblemDetails | void>(params?: GetOrganizationRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationRolesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationRoles>>> = ({ signal }) => getOrganizationRoles(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationRoles>>>
export type GetOrganizationRolesQueryError = ProblemDetails | void


export function useGetOrganizationRoles<TData = Awaited<ReturnType<typeof getOrganizationRoles>>, TError = ProblemDetails | void>(
 params: undefined |  GetOrganizationRolesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoles<TData = Awaited<ReturnType<typeof getOrganizationRoles>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoles<TData = Awaited<ReturnType<typeof getOrganizationRoles>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Roles
 */

export function useGetOrganizationRoles<TData = Awaited<ReturnType<typeof getOrganizationRoles>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationRolesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrganizationRolesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationRoles>>, TError = ProblemDetails | void>(params?: GetOrganizationRolesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationRolesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationRoles>>> = ({ signal }) => getOrganizationRoles(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetOrganizationRolesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationRoles>>>
export type GetOrganizationRolesSuspenseQueryError = ProblemDetails | void


export function useGetOrganizationRolesSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoles>>, TError = ProblemDetails | void>(
 params: undefined |  GetOrganizationRolesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRolesSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoles>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRolesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRolesSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoles>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRolesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Roles
 */

export function useGetOrganizationRolesSuspense<TData = Awaited<ReturnType<typeof getOrganizationRoles>>, TError = ProblemDetails | void>(
 params?: GetOrganizationRolesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationRolesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get an organization role by ID.
 * @summary Get Organization Role
 */
export const getOrganizationRole = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<OrganizationRole>(
      {url: `/idm/v3/organization-roles/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetOrganizationRoleQueryKey = (id: string,) => {
    return [
    `/idm/v3/organization-roles/${id}`
    ] as const;
    }


export const getGetOrganizationRoleQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationRoleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationRole>>> = ({ signal }) => getOrganizationRole(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationRole>>>
export type GetOrganizationRoleQueryError = ProblemDetails


export function useGetOrganizationRole<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRole>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRole>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRole<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRole>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRole>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRole<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Role
 */

export function useGetOrganizationRole<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationRoleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOrganizationRoleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationRoleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationRole>>> = ({ signal }) => getOrganizationRole(id, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetOrganizationRoleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationRole>>>
export type GetOrganizationRoleSuspenseQueryError = ProblemDetails


export function useGetOrganizationRoleSuspense<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoleSuspense<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoleSuspense<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Role
 */

export function useGetOrganizationRoleSuspense<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationRoleSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Create or update an organization role identified by an immutable client-provided ID. The role display name must be unique within the owning organization.
 * @summary Create or Update Organization Role
 */
export const updateOrganizationRole = (
    id: string,
    organizationRoleRequest: OrganizationRoleRequest,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v3/organization-roles/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: organizationRoleRequest, signal
    },
      );
    }




export const getUpdateOrganizationRoleMutationKey = () => ['updateOrganizationRole'] as const;

export const getUpdateOrganizationRoleMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationRole>>, TError,UpdateOrganizationRoleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationRole>>, TError,UpdateOrganizationRoleMutationVariables, TContext> => {

const mutationKey = getUpdateOrganizationRoleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationRole>>, UpdateOrganizationRoleMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrganizationRole(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationRole>>>
    export type UpdateOrganizationRoleMutationBody = OrganizationRoleRequest
    export type UpdateOrganizationRoleMutationError = ProblemDetails | void
    export type UpdateOrganizationRoleMutationVariables = {id: string;data: OrganizationRoleRequest}

    /**
 * @summary Create or Update Organization Role
 */
export const useUpdateOrganizationRole = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationRole>>, TError,UpdateOrganizationRoleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationRole>>,
        TError,
        UpdateOrganizationRoleMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOrganizationRoleMutationOptions(options), queryClient);
    }

/**
 * Delete an organization role. Will fail if the role has active assignments.
 * @summary Delete Organization Role
 */
export const deleteOrganizationRole = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v3/organization-roles/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteOrganizationRoleMutationKey = () => ['deleteOrganizationRole'] as const;

export const getDeleteOrganizationRoleMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationRole>>, TError,DeleteOrganizationRoleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationRole>>, TError,DeleteOrganizationRoleMutationVariables, TContext> => {

const mutationKey = getDeleteOrganizationRoleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganizationRole>>, DeleteOrganizationRoleMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteOrganizationRole(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganizationRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganizationRole>>>

    export type DeleteOrganizationRoleMutationError = ProblemDetails | void
    export type DeleteOrganizationRoleMutationVariables = {id: string}

    /**
 * @summary Delete Organization Role
 */
export const useDeleteOrganizationRole = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationRole>>, TError,DeleteOrganizationRoleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrganizationRole>>,
        TError,
        DeleteOrganizationRoleMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOrganizationRoleMutationOptions(options), queryClient);
    }

/**
 * Get a list of services.
 * @summary Get Services
 */
export const getServices = (

 signal?: AbortSignal
) => {


      return fetchInstance<Service[]>(
      {url: `/idm/v3/services`, method: 'GET', signal
    },
      );
    }




export const getGetServicesQueryKey = () => {
    return [
    `/idm/v3/services`
    ] as const;
    }


export const getGetServicesQueryOptions = <TData = Awaited<ReturnType<typeof getServices>>, TError = ProblemDetails | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServices>>> = ({ signal }) => getServices(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getServices>>>
export type GetServicesQueryError = ProblemDetails | void


export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = ProblemDetails | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServices>>,
          TError,
          Awaited<ReturnType<typeof getServices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServices>>,
          TError,
          Awaited<ReturnType<typeof getServices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Services
 */

export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetServicesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServices>>, TError = ProblemDetails | void>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServices>>> = ({ signal }) => getServices(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetServicesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServices>>>
export type GetServicesSuspenseQueryError = ProblemDetails | void


export function useGetServicesSuspense<TData = Awaited<ReturnType<typeof getServices>>, TError = ProblemDetails | void>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicesSuspense<TData = Awaited<ReturnType<typeof getServices>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicesSuspense<TData = Awaited<ReturnType<typeof getServices>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Services
 */

export function useGetServicesSuspense<TData = Awaited<ReturnType<typeof getServices>>, TError = ProblemDetails | void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get a list of users with optional pagination.
 * @summary Get Users
 */
export const getUsers = (
    params?: GetUsersParams,
 signal?: AbortSignal
) => {


      return fetchInstance<PaginatedUsers>(
      {url: `/idm/v4/users`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetUsersQueryKey = (params?: GetUsersParams,) => {
    return [
    `/idm/v4/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUsers>>, TError = ProblemDetails | void>(params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) => getUsers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersQueryError = ProblemDetails | void


export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = ProblemDetails | void>(
 params: undefined |  GetUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = ProblemDetails | void>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = ProblemDetails | void>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Users
 */

export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = ProblemDetails | void>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUsers>>, TError = ProblemDetails | void>(params?: GetUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) => getUsers(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersSuspenseQueryError = ProblemDetails | void


export function useGetUsersSuspense<TData = Awaited<ReturnType<typeof getUsers>>, TError = ProblemDetails | void>(
 params: undefined |  GetUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersSuspense<TData = Awaited<ReturnType<typeof getUsers>>, TError = ProblemDetails | void>(
 params?: GetUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersSuspense<TData = Awaited<ReturnType<typeof getUsers>>, TError = ProblemDetails | void>(
 params?: GetUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Users
 */

export function useGetUsersSuspense<TData = Awaited<ReturnType<typeof getUsers>>, TError = ProblemDetails | void>(
 params?: GetUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete a user
 * @summary Delete User
 */
export const deleteUser = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v4/users/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteUserMutationKey = () => ['deleteUser'] as const;

export const getDeleteUserMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,DeleteUserMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,DeleteUserMutationVariables, TContext> => {

const mutationKey = getDeleteUserMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, DeleteUserMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteUser(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

    export type DeleteUserMutationError = ProblemDetails | void
    export type DeleteUserMutationVariables = {id: string}

    /**
 * @summary Delete User
 */
export const useDeleteUser = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,DeleteUserMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        DeleteUserMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options), queryClient);
    }

/**
 * Get an user by id
 * @summary Get User
 */
export const getUser = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<User>(
      {url: `/idm/v4/users/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetUserQueryKey = (id: string,) => {
    return [
    `/idm/v4/users/${id}`
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails | void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ProblemDetails | void


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails | void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get User
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails | void>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(id, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserSuspenseQueryError = ProblemDetails | void


export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails | void>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get User
 */

export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update a user
 * @summary Update User
 */
export const updateUser = (
    id: string,
    userRequest: UserRequest,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v4/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userRequest, signal
    },
      );
    }




export const getUpdateUserMutationKey = () => ['updateUser'] as const;

export const getUpdateUserMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext> => {

const mutationKey = getUpdateUserMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, UpdateUserMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateUser(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UserRequest
    export type UpdateUserMutationError = ProblemDetails | void
    export type UpdateUserMutationVariables = {id: string;data: UserRequest}

    /**
 * @summary Update User
 */
export const useUpdateUser = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        UpdateUserMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options), queryClient);
    }

/**
 * Invite user again
 * @summary Reinvite
 */
export const reinvite = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v4/users/${id}/reinvite`, method: 'POST', signal
    },
      );
    }




export const getReinviteMutationKey = () => ['reinvite'] as const;

export const getReinviteMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reinvite>>, TError,ReinviteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reinvite>>, TError,ReinviteMutationVariables, TContext> => {

const mutationKey = getReinviteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reinvite>>, ReinviteMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  reinvite(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReinviteMutationResult = NonNullable<Awaited<ReturnType<typeof reinvite>>>

    export type ReinviteMutationError = ProblemDetails | void
    export type ReinviteMutationVariables = {id: string}

    /**
 * @summary Reinvite
 */
export const useReinvite = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reinvite>>, TError,ReinviteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reinvite>>,
        TError,
        ReinviteMutationVariables,
        TContext
      > => {
      return useMutation(getReinviteMutationOptions(options), queryClient);
    }

/**
 * Reset the users MFA devices
 * @summary Reset MFA
 */
export const resetmfa = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v4/users/${id}/resetmfa`, method: 'POST', signal
    },
      );
    }




export const getResetmfaMutationKey = () => ['resetmfa'] as const;

export const getResetmfaMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetmfa>>, TError,ResetmfaMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resetmfa>>, TError,ResetmfaMutationVariables, TContext> => {

const mutationKey = getResetmfaMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetmfa>>, ResetmfaMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  resetmfa(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetmfaMutationResult = NonNullable<Awaited<ReturnType<typeof resetmfa>>>

    export type ResetmfaMutationError = ProblemDetails | void
    export type ResetmfaMutationVariables = {id: string}

    /**
 * @summary Reset MFA
 */
export const useResetmfa = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetmfa>>, TError,ResetmfaMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetmfa>>,
        TError,
        ResetmfaMutationVariables,
        TContext
      > => {
      return useMutation(getResetmfaMutationOptions(options), queryClient);
    }

/**
 * Reset password
 * @summary ResetPassword
 */
export const resetpassword = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<void>(
      {url: `/idm/v4/users/${id}/resetpassword`, method: 'POST', signal
    },
      );
    }




export const getResetpasswordMutationKey = () => ['resetpassword'] as const;

export const getResetpasswordMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetpassword>>, TError,ResetpasswordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resetpassword>>, TError,ResetpasswordMutationVariables, TContext> => {

const mutationKey = getResetpasswordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetpassword>>, ResetpasswordMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  resetpassword(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetpasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetpassword>>>

    export type ResetpasswordMutationError = ProblemDetails | void
    export type ResetpasswordMutationVariables = {id: string}

    /**
 * @summary ResetPassword
 */
export const useResetpassword = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetpassword>>, TError,ResetpasswordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetpassword>>,
        TError,
        ResetpasswordMutationVariables,
        TContext
      > => {
      return useMutation(getResetpasswordMutationOptions(options), queryClient);
    }

/**
 * Get a list of audit events, including user actions and system events, for tracking changes and activities within the system.
 * @summary Get Audit Events
 */
export const getAuditEvents = (
    params: GetAuditEventsParams,
 signal?: AbortSignal
) => {


      return fetchInstance<AuditEvent[]>(
      {url: `/idm/v2/audit-events`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetAuditEventsQueryKey = (params?: GetAuditEventsParams,) => {
    return [
    `/idm/v2/audit-events`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAuditEventsQueryOptions = <TData = Awaited<ReturnType<typeof getAuditEvents>>, TError = ProblemDetails | void>(params: GetAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditEvents>>> = ({ signal }) => getAuditEvents(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditEvents>>>
export type GetAuditEventsQueryError = ProblemDetails | void


export function useGetAuditEvents<TData = Awaited<ReturnType<typeof getAuditEvents>>, TError = ProblemDetails | void>(
 params: GetAuditEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditEvents>>,
          TError,
          Awaited<ReturnType<typeof getAuditEvents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditEvents<TData = Awaited<ReturnType<typeof getAuditEvents>>, TError = ProblemDetails | void>(
 params: GetAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditEvents>>,
          TError,
          Awaited<ReturnType<typeof getAuditEvents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditEvents<TData = Awaited<ReturnType<typeof getAuditEvents>>, TError = ProblemDetails | void>(
 params: GetAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Audit Events
 */

export function useGetAuditEvents<TData = Awaited<ReturnType<typeof getAuditEvents>>, TError = ProblemDetails | void>(
 params: GetAuditEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAuditEventsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAuditEvents>>, TError = ProblemDetails | void>(params: GetAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditEvents>>> = ({ signal }) => getAuditEvents(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAuditEventsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditEvents>>>
export type GetAuditEventsSuspenseQueryError = ProblemDetails | void


export function useGetAuditEventsSuspense<TData = Awaited<ReturnType<typeof getAuditEvents>>, TError = ProblemDetails | void>(
 params: GetAuditEventsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditEventsSuspense<TData = Awaited<ReturnType<typeof getAuditEvents>>, TError = ProblemDetails | void>(
 params: GetAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditEventsSuspense<TData = Awaited<ReturnType<typeof getAuditEvents>>, TError = ProblemDetails | void>(
 params: GetAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Audit Events
 */

export function useGetAuditEventsSuspense<TData = Awaited<ReturnType<typeof getAuditEvents>>, TError = ProblemDetails | void>(
 params: GetAuditEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuditEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditEventsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Path organizationId must match caller organization scope.
 * @summary Export organization audit timeline as CSV or JSON by setting accept headers.
 */
export const exportOrganizationAuditTimeline = (
    organizationId: string,
    params: ExportOrganizationAuditTimelineParams,
 signal?: AbortSignal
) => {


      return fetchInstance<string | AuditEventV3[]>(
      {url: `/idm/v3/audit-events/organizations/${organizationId}/export`, method: 'GET',
        params, signal
    },
      );
    }




export const getExportOrganizationAuditTimelineQueryKey = (organizationId: string,
    params?: ExportOrganizationAuditTimelineParams,) => {
    return [
    `/idm/v3/audit-events/organizations/${organizationId}/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportOrganizationAuditTimelineQueryOptions = <TData = Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError = ProblemDetails>(organizationId: string,
    params: ExportOrganizationAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportOrganizationAuditTimelineQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>> = ({ signal }) => exportOrganizationAuditTimeline(organizationId,params, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportOrganizationAuditTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>>
export type ExportOrganizationAuditTimelineQueryError = ProblemDetails


export function useExportOrganizationAuditTimeline<TData = Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationAuditTimelineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportOrganizationAuditTimeline<TData = Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportOrganizationAuditTimeline<TData = Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export organization audit timeline as CSV or JSON by setting accept headers.
 */

export function useExportOrganizationAuditTimeline<TData = Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportOrganizationAuditTimelineQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getExportOrganizationAuditTimelineSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError = ProblemDetails>(organizationId: string,
    params: ExportOrganizationAuditTimelineParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportOrganizationAuditTimelineQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>> = ({ signal }) => exportOrganizationAuditTimeline(organizationId,params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportOrganizationAuditTimelineSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>>
export type ExportOrganizationAuditTimelineSuspenseQueryError = ProblemDetails


export function useExportOrganizationAuditTimelineSuspense<TData = Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationAuditTimelineParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportOrganizationAuditTimelineSuspense<TData = Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationAuditTimelineParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportOrganizationAuditTimelineSuspense<TData = Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationAuditTimelineParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export organization audit timeline as CSV or JSON by setting accept headers.
 */

export function useExportOrganizationAuditTimelineSuspense<TData = Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationAuditTimelineParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationAuditTimeline>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportOrganizationAuditTimelineSuspenseQueryOptions(organizationId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Export includes each user and application pair with the most recent login since the given from timestamp, and path organizationId must match caller organization scope.
 * @summary Export organization users last login report as CSV or JSON
 */
export const exportOrganizationLastLogins = (
    organizationId: string,
    params: ExportOrganizationLastLoginsParams,
 signal?: AbortSignal
) => {


      return fetchInstance<string | LastLoginsResponse[]>(
      {url: `/idm/v3/audit-events/organizations/${organizationId}/last-logins`, method: 'GET',
        params, signal
    },
      );
    }




export const getExportOrganizationLastLoginsQueryKey = (organizationId: string,
    params?: ExportOrganizationLastLoginsParams,) => {
    return [
    `/idm/v3/audit-events/organizations/${organizationId}/last-logins`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportOrganizationLastLoginsQueryOptions = <TData = Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError = ProblemDetails>(organizationId: string,
    params: ExportOrganizationLastLoginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportOrganizationLastLoginsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOrganizationLastLogins>>> = ({ signal }) => exportOrganizationLastLogins(organizationId,params, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportOrganizationLastLoginsQueryResult = NonNullable<Awaited<ReturnType<typeof exportOrganizationLastLogins>>>
export type ExportOrganizationLastLoginsQueryError = ProblemDetails


export function useExportOrganizationLastLogins<TData = Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationLastLoginsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportOrganizationLastLogins>>,
          TError,
          Awaited<ReturnType<typeof exportOrganizationLastLogins>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportOrganizationLastLogins<TData = Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationLastLoginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportOrganizationLastLogins>>,
          TError,
          Awaited<ReturnType<typeof exportOrganizationLastLogins>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportOrganizationLastLogins<TData = Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationLastLoginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export organization users last login report as CSV or JSON
 */

export function useExportOrganizationLastLogins<TData = Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationLastLoginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportOrganizationLastLoginsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getExportOrganizationLastLoginsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError = ProblemDetails>(organizationId: string,
    params: ExportOrganizationLastLoginsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportOrganizationLastLoginsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOrganizationLastLogins>>> = ({ signal }) => exportOrganizationLastLogins(organizationId,params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportOrganizationLastLoginsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof exportOrganizationLastLogins>>>
export type ExportOrganizationLastLoginsSuspenseQueryError = ProblemDetails


export function useExportOrganizationLastLoginsSuspense<TData = Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationLastLoginsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportOrganizationLastLoginsSuspense<TData = Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationLastLoginsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportOrganizationLastLoginsSuspense<TData = Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationLastLoginsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export organization users last login report as CSV or JSON
 */

export function useExportOrganizationLastLoginsSuspense<TData = Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError = ProblemDetails>(
 organizationId: string,
    params: ExportOrganizationLastLoginsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportOrganizationLastLogins>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportOrganizationLastLoginsSuspenseQueryOptions(organizationId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get a service account by id
 * @deprecated
 * @summary Get ServiceAccount
 */
export const getServiceAccountV2 = (
    id: string,
 signal?: AbortSignal
) => {


      return fetchInstance<ServiceAccountResponseV2>(
      {url: `/idm/v2/service-accounts/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetServiceAccountV2QueryKey = (id: string,) => {
    return [
    `/idm/v2/service-accounts/${id}`
    ] as const;
    }


export const getGetServiceAccountV2QueryOptions = <TData = Awaited<ReturnType<typeof getServiceAccountV2>>, TError = ProblemDetails | void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceAccountV2QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceAccountV2>>> = ({ signal }) => getServiceAccountV2(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceAccountV2QueryResult = NonNullable<Awaited<ReturnType<typeof getServiceAccountV2>>>
export type GetServiceAccountV2QueryError = ProblemDetails | void


export function useGetServiceAccountV2<TData = Awaited<ReturnType<typeof getServiceAccountV2>>, TError = ProblemDetails | void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceAccountV2>>,
          TError,
          Awaited<ReturnType<typeof getServiceAccountV2>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccountV2<TData = Awaited<ReturnType<typeof getServiceAccountV2>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceAccountV2>>,
          TError,
          Awaited<ReturnType<typeof getServiceAccountV2>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccountV2<TData = Awaited<ReturnType<typeof getServiceAccountV2>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Get ServiceAccount
 */

export function useGetServiceAccountV2<TData = Awaited<ReturnType<typeof getServiceAccountV2>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceAccountV2QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetServiceAccountV2SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServiceAccountV2>>, TError = ProblemDetails | void>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceAccountV2QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceAccountV2>>> = ({ signal }) => getServiceAccountV2(id, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetServiceAccountV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceAccountV2>>>
export type GetServiceAccountV2SuspenseQueryError = ProblemDetails | void


export function useGetServiceAccountV2Suspense<TData = Awaited<ReturnType<typeof getServiceAccountV2>>, TError = ProblemDetails | void>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccountV2Suspense<TData = Awaited<ReturnType<typeof getServiceAccountV2>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAccountV2Suspense<TData = Awaited<ReturnType<typeof getServiceAccountV2>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Get ServiceAccount
 */

export function useGetServiceAccountV2Suspense<TData = Awaited<ReturnType<typeof getServiceAccountV2>>, TError = ProblemDetails | void>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceAccountV2>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceAccountV2SuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get a list of market participants.
 * @deprecated
 * @summary Get Market Participants
 */
export const getMarketParticipants = (
    params?: GetMarketParticipantsParams,
 signal?: AbortSignal
) => {


      return fetchInstance<MarketParticipant[]>(
      {url: `/idm/v1/market-participants`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetMarketParticipantsQueryKey = (params?: GetMarketParticipantsParams,) => {
    return [
    `/idm/v1/market-participants`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMarketParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof getMarketParticipants>>, TError = ProblemDetails | void>(params?: GetMarketParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketParticipantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketParticipants>>> = ({ signal }) => getMarketParticipants(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketParticipants>>>
export type GetMarketParticipantsQueryError = ProblemDetails | void


export function useGetMarketParticipants<TData = Awaited<ReturnType<typeof getMarketParticipants>>, TError = ProblemDetails | void>(
 params: undefined |  GetMarketParticipantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketParticipants>>,
          TError,
          Awaited<ReturnType<typeof getMarketParticipants>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketParticipants<TData = Awaited<ReturnType<typeof getMarketParticipants>>, TError = ProblemDetails | void>(
 params?: GetMarketParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketParticipants>>,
          TError,
          Awaited<ReturnType<typeof getMarketParticipants>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketParticipants<TData = Awaited<ReturnType<typeof getMarketParticipants>>, TError = ProblemDetails | void>(
 params?: GetMarketParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Get Market Participants
 */

export function useGetMarketParticipants<TData = Awaited<ReturnType<typeof getMarketParticipants>>, TError = ProblemDetails | void>(
 params?: GetMarketParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketParticipantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMarketParticipantsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMarketParticipants>>, TError = ProblemDetails | void>(params?: GetMarketParticipantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketParticipantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketParticipants>>> = ({ signal }) => getMarketParticipants(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMarketParticipantsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketParticipants>>>
export type GetMarketParticipantsSuspenseQueryError = ProblemDetails | void


export function useGetMarketParticipantsSuspense<TData = Awaited<ReturnType<typeof getMarketParticipants>>, TError = ProblemDetails | void>(
 params: undefined |  GetMarketParticipantsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketParticipantsSuspense<TData = Awaited<ReturnType<typeof getMarketParticipants>>, TError = ProblemDetails | void>(
 params?: GetMarketParticipantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketParticipantsSuspense<TData = Awaited<ReturnType<typeof getMarketParticipants>>, TError = ProblemDetails | void>(
 params?: GetMarketParticipantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Get Market Participants
 */

export function useGetMarketParticipantsSuspense<TData = Awaited<ReturnType<typeof getMarketParticipants>>, TError = ProblemDetails | void>(
 params?: GetMarketParticipantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketParticipants>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketParticipantsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
